import EffectQueue from '../EffectQueue/EffectQueue';
import { EFFECT_TAG, EFFECT_LEVEL } from '../../enums/index';
import LongTaskScheduler  from '../LongTaskScheduler';

/**
* 基础节点
*/
class BaseNode {
  constructor(renderProps, funType, rendrenOption) {
    this.effects = new EffectQueue(); // 副作用队列
    this.funType = funType;  // 业务类别 灯 还是 点
    this.parent = null; // nodeQueue列表
    this.renderData = {
      zIndex: renderProps.zIndex || rendrenOption.zIndex || 0
    }

    // 不删除zindex Konva会warning提示
    const rendrenOptionNoZindex = Object.assign({}, rendrenOption);

    delete rendrenOptionNoZindex.zIndex;

    this.init(renderProps, rendrenOptionNoZindex);
  }
  
  // 处理节点上的所有副作用
  flushEffects(isClearQueue = true) {
    // 副作用队列
    const effectsQueue = this.effects.queue || [];

    // 删除
    if (
      (this.flags & EFFECT_TAG.DELETE) === EFFECT_TAG.DELETE
    ) {
      this.handlerDestroy();
    }

    effectsQueue.forEach(effect => {
      switch (effect.flag) {
        // 移动
        case EFFECT_TAG.MOVE:
          this.runWithLongTask(
            effect,
            this.handlerMove.bind(this, effect)
          );
          break;
        // 点定位
        case EFFECT_TAG.POSITION:
          this.runWithLongTask(
            effect,
            this.handlerPosition.bind(this, effect)
          );
          break;
        // 线定位
        case EFFECT_TAG.POINTS:
          this.runWithLongTask(
            effect,
            this.handlerPoints.bind(this, effect)
          );
          break;
        // 线定位
        case EFFECT_TAG.RADIUS:
          this.runWithLongTask(
            effect,
            this.handlerRadius.bind(this, effect)
          );
          break;
        // 仅仅更新数据 并不节点操作
        case EFFECT_TAG.UPDATE_RENDER_DATA:
          this.handlerUpdateRenderData(effect.payload);
        default:
          break;
      }

      // 执行回调任务
      effect.callBack instanceof Function && effect.callBack();
    })

    // 清空队列重的所有副作用
    if (isClearQueue) this.effects.clear();
  }

  // 对长任务进行绑定处理
  runWithLongTask(effect, task) {
    // 低优先级 推入长任务列表 空闲时间执行
    if (
      LongTaskScheduler.isSupportIdeCallback &&
      effect.level === EFFECT_LEVEL.LOW
    ) {
      LongTaskScheduler.addTask(() => {
        // 执行方法
        task();
        // 用于长任务全部处理完成后 一次性渲染
        return this.parent.render;
      });
    } else {
      // 高优先级直接同步执行
      task();
    }
  }

  // 删除node操作
  // 由于删除节点性能特别差固定低优先级任务
  handlerDestroy() {
    // 在1万节点操作上 requestIdleCallback 可将destory 1.2s 卡顿 降级到 13ms
    if (LongTaskScheduler.isSupportIdeCallback) {
      // 优先透明操作
      this.stateNode.opacity(0);

      // 此处支持requestIdleCallback的浏览器将推入长任务 在后续浏览器空闲的时候再执行
      LongTaskScheduler.addTask(() => {
        this.stateNode.destroy();

        return this.parent.render;
      });
    } else {
      // 不支持api的则降级直接删除
      this.stateNode.destroy();
    }
  }
}

export default BaseNode;